import React from "react";
import { Card, CardContent, Grid, Typography, Box, LinearProgress } from "@mui/material";
import {
  PeopleAlt as PeopleAltIcon,
  ShoppingCart as ShoppingCartIcon,
  MonetizationOn as MonetizationOnIcon,
  TrendingUp as TrendingUpIcon,
  ArrowUpward as ArrowUpwardIcon,
} from "@mui/icons-material";

// Custom styling constants
const theme = {
  primary: "#1976D2",
  success: "#2E7D32",
  warning: "#ED6C02",
  error: "#D32F2F",
  text: "#2c3e50",
  background: "#f8f9fa",
};

const Dashboard = () => {
  return (
    <Box sx={{ padding: 3, backgroundColor: theme.background }}>
      <Typography variant="h4" sx={{ marginBottom: 3, fontWeight: 600, color: theme.text }}>
        Dashboard Overview
      </Typography>

      {/* Key Metrics Cards */}
      <Grid container spacing={3} sx={{ marginBottom: 3 }}>
        {[
          { title: "Total Users", value: "150", icon: <PeopleAltIcon />, color: theme.primary },
          { title: "Total Orders", value: "320", icon: <ShoppingCartIcon />, color: theme.success },
          { title: "Revenue", value: "$12,500", icon: <MonetizationOnIcon />, color: theme.warning },
          { title: "Profit Growth", value: "8.5%", icon: <TrendingUpIcon />, color: theme.error },
        ].map((metric, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                background: `linear-gradient(135deg, ${metric.color}20, transparent)`,
                borderRadius: 2,
                borderLeft: `4px solid ${metric.color}`,
                boxShadow: 3,
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.03)" },
              }}
            >
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box sx={{ fontSize: 40, color: metric.color }}>{metric.icon}</Box>
                <Box>
                  <Typography variant="subtitle1" color={theme.text}>
                    {metric.title}
                  </Typography>
                  <Typography variant="h5" fontWeight={600} color={metric.color}>
                    {metric.value} {index === 3 && <ArrowUpwardIcon fontSize="small" sx={{ color: theme.error }} />}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Analytics Section */}
      <Grid container spacing={3} sx={{ marginBottom: 3 }}>
        {[
          { title: "User Growth", percent: 75, color: theme.primary },
          { title: "Order Fulfillment", percent: 90, color: theme.success },
          { title: "Revenue Target", percent: 60, color: theme.warning },
        ].map((progress, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" color={theme.text} sx={{ fontWeight: 500 }}>
                  {progress.title}
                </Typography>
                <Box sx={{ width: "100%", mt: 2 }}>
                  <LinearProgress
                    variant="determinate"
                    value={progress.percent}
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      "& .MuiLinearProgress-bar": { backgroundColor: progress.color },
                    }}
                  />
                </Box>
                <Typography sx={{ textAlign: "right", fontWeight: 500, mt: 1 }} color={theme.text}>
                  {progress.percent}%
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* User Management Table Placeholder */}
      <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" color={theme.text} sx={{ fontWeight: 600 }}>
            User Management
          </Typography>
          <Typography sx={{ color: theme.text, mt: 2 }}>Table content goes here...</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Dashboard;
